export default {
	label: 'Muudatuste ajalugu',
	changeNotice: '{firstname} {lastname} tegi {count} muudatuse {time}: | {firstname} {lastname} tegi {count} muudatust {time}:',
	method: {
		title: 'Meede',
		fields: {
			status: 'Staatus',
			due_date: 'Tähtajani',
			priority: 'Prioriteet',
			comment: 'Kommentaar',
			price: 'Hind',
			responsible: 'Vastutaja',
			updated_at: 'Viimane kontroll',
			jira_url: 'Jira URL',
		},
	},
	rules: {
		label: 'Reeglid',
		fields: {
			status: 'Staatus',
			comment: 'Kommentaar',
		},
	},
}
